// Origem da visita (UTM, click ids, referrer) para gravar junto do lead na API.
//
// first_touch → localStorage, 90 dias, não é sobrescrito enquanto válido.
// last_touch  → sessionStorage, capturado no 1º carregamento de cada visita (sessão).

const FIRST_KEY = 'dpf_first_touch';
const LAST_KEY = 'dpf_last_touch';
const FIRST_TTL_MS = 90 * 24 * 60 * 60 * 1000;
const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
const OWN_DOMAIN = 'djparafestas.com.br';
const MAX_LEN = 255;

const clip = (v) => (v ? String(v).slice(0, MAX_LEN) : null);

const read = (storage, key) => {
    try {
        const raw = storage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
};

const write = (storage, key, value) => {
    try {
        storage.setItem(key, JSON.stringify(value));
    } catch (e) {
        // storage bloqueado (aba anônima etc.) — segue sem atribuição
    }
};

// Referrer externo, sem query/hash (pode carregar termos de busca ou dados do usuário).
const externalReferrer = () => {
    const ref = document.referrer;
    if (!ref) return null;
    try {
        const { hostname } = new URL(ref);
        if (hostname === OWN_DOMAIN || hostname.endsWith(`.${OWN_DOMAIN}`)) return null;
    } catch (e) {
        // esquemas como android-app:// — mantém
    }
    return clip(ref.split(/[?#]/)[0]);
};

const buildTouch = () => {
    const query = new URLSearchParams(window.location.search);
    const touch = { captured_at: Date.now() };
    PARAMS.forEach((p) => { touch[p] = clip(query.get(p)); });
    touch.referrer = externalReferrer();
    touch.landing_page = clip(window.location.pathname);
    return touch;
};

// Chamar uma vez, no carregamento do app (antes de qualquer navegação interna).
export function captureAttribution() {
    if (typeof window === 'undefined' || /ReactSnap/i.test(navigator.userAgent)) return;

    let session;
    try { session = window.sessionStorage; } catch (e) { return; }
    if (read(session, LAST_KEY)) return; // não é o 1º carregamento desta visita

    const touch = buildTouch();
    write(session, LAST_KEY, touch);

    let local;
    try { local = window.localStorage; } catch (e) { return; }
    const first = read(local, FIRST_KEY);
    if (!first || !first.captured_at || Date.now() - first.captured_at > FIRST_TTL_MS) {
        write(local, FIRST_KEY, touch);
    }
}

// client_id do GA a partir do cookie _ga ("GA1.1.123456789.1700000000" → "123456789.1700000000").
const gaClientId = () => {
    const cookie = document.cookie.split('; ').find((c) => c.startsWith('_ga='));
    if (!cookie) return null;
    const parts = cookie.slice(4).split('.');
    return parts.length >= 4 ? parts.slice(-2).join('.') : null;
};

const stripMeta = (touch) => {
    if (!touch) return null;
    const { captured_at, ...rest } = touch;
    return rest;
};

// Campos extras para o payload de /leads/instant e /leads/direct.
export function attributionPayload() {
    let first = null;
    let last = null;
    try { first = read(window.localStorage, FIRST_KEY); } catch (e) { /* bloqueado */ }
    try { last = read(window.sessionStorage, LAST_KEY); } catch (e) { /* bloqueado */ }
    return {
        first_touch: stripMeta(first),
        last_touch: stripMeta(last),
        ga_client_id: gaClientId(),
    };
}
